module.exports = __webpack_public_path__ + "img/gif.743f1fa3.svg";